import { Output, ChangeDetectionStrategy, Component, Input, EventEmitter, Type } from "@angular/core";
import { ModalComponent } from "../../modal/modal.component";
import { MoreMenu } from "./more.menu";
import { DynamicContentComponent } from "../../dynamic-content/dynamic.content.component";
import { S25RouterLinkDirective } from "../s25.router.link.directive";
import { S25Const } from "../../../util/s25-const";
import { ModalService } from "../../modal/modal.service";

@Component({
    selector: "s25-ng-more-menu-item",
    template: `
        @if (item.modal) {
            <button type="button" class="more-menu-item-button" (click)="openModal(item.modal!)">
                {{ item.displayName }}
            </button>
        } @else if (item.state) {
            <a
                s25-ng-router-link
                [stateName]="item.state.name"
                [options]="item.stateGoOptions"
                (click)="itemClicked.emit()"
                >{{ item.displayName }}</a
            >
        } @else if (item.url) {
            <a [href]="item.url" (click)="handleUrlClick($event, item.url)">{{ item.displayName }}</a>
        } @else if (item.dynamicValue) {
            <s25-ng-dynamic-content [dynamicValue]="item.dynamicValue"></s25-ng-dynamic-content>
        }
    `,
    styles: `
        a,
        .more-menu-item-button {
            display: block;
        }

        /* necessary because there's no href. convert to button? */
        .more-menu-item-button {
            width: 100%;
            margin: 0;
            padding: 0.5rem 2.5rem;
            border: 0;
            background: transparent;
            text-align: left;
            font: inherit;
            cursor: pointer;
            color: var(--color--link-text);

            &:hover,
            &:focus-visible {
                color: var(--color--link-text-hover);
            }
        }
    `,
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DynamicContentComponent, S25RouterLinkDirective],
})
export class S25MoreMenuItemComponent {
    @Input() item: MoreMenu.MenuItem;
    @Output() itemClicked = new EventEmitter<void>();

    openModal(modal: Type<ModalComponent>): void {
        this.itemClicked.emit();
        void ModalService.byClass(modal);
    }

    handleUrlClick(event: Event, url: string) {
        if (S25Const.inApp && url.startsWith("app://")) {
            event.preventDefault();
            event.stopPropagation();
            url = url.replace("app://", "https://"); // when navigating links in app, `app://` precedes the url, but external links need `https://` to navigate using device's default browser
            window.open(url, "_system");
        }
        this.itemClicked.emit();
    }

    //This component gives us a central place for all possible components we might need as more menu items.
    /*
    The menu items are often
    - simple links eg. <a href="">
    - Modal components - they open a modal via class
    - state change link

    They can also be any other component. I think we'll be happiest if we have some pre built features, and an option to dynamically render the passed in component.
     */
}
